<template>
	<pop-up-wrapper>
		<div :style="pos" class="pop-up-choose-resource">
			<router-link :to="{ name: 'Question' }">
				Questions Flash</router-link
			>
			<router-link :to="{ name: 'Key' }">Activités Expresso</router-link>
			<router-link :to="{ name: 'ExerciseSheet' }"
				>Exercices Classico</router-link
			>
		</div>
	</pop-up-wrapper>
</template>


<script>
import PopUpWrapper from '../PopUpWrapper.vue'
export default {
	components: { PopUpWrapper },
	props: {
		x: Number,
		y: Number
	},
	data() {
		return {
			pos: '',
		}
	},
	created() {
		let style = `left: calc(${this.x}px - 15vw); top: ${this.y}px;`
		this.pos = style
	},
}
</script>

<style>
</style>
